import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { Group } from '../models/group.model';

@Pipe({
  name: 'searchGroups',
})
@Injectable()
export class SearchGroupsPipe implements PipeTransform {
  transform(groups: Group[], searchText: string): Group[] {
    if (!searchText) {
      return groups;
    }

    return groups.filter(group => group.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1);
  }
}
